module.exports = __webpack_public_path__ + "img/illu-signature-shield.6140e303.svg";